/* eslint-disable no-bitwise */
import util from './util';


// Base64 code adapted from javascriptbase64 (MIT license - https://code.google.com/p/javascriptbase64/)
// Copyright (c) 2008 Fred Palmer fred.palmer_at_gmail.com
const base64 = (function makeBase64() {
  const base64Codex = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  function Utf8EncodeEnumerator(input) {
    this.input = `${input}`;
    this.index = -1;
    this.buffer = [];
  }

  Utf8EncodeEnumerator.prototype = {
    current: Number.NaN,

    moveNext() {
      if (this.buffer.length > 0) {
        this.current = this.buffer.shift();
        return true;
      } if (this.index >= (this.input.length - 1)) {
        this.current = Number.NaN;
        return false;
      }
      let charCode = this.input.charCodeAt(++this.index);

      // "\r\n" -> "\n"
      //
      if ((charCode === 13) && (this.input.charCodeAt(this.index + 1) === 10)) {
        charCode = 10;
        this.index += 2;
      }

      if (charCode < 128) {
        this.current = charCode;
      } else if ((charCode > 127) && (charCode < 2048)) {
        this.current = (charCode >> 6) | 192;
        this.buffer.push((charCode & 63) | 128);
      } else {
        this.current = (charCode >> 12) | 224;
        this.buffer.push(((charCode >> 6) & 63) | 128);
        this.buffer.push((charCode & 63) | 128);
      }

      return true;
    }
  };

  function Base64DecodeEnumerator(input) {
    this.input = input;
    this.index = -1;
    this.buffer = [];
  }

  Base64DecodeEnumerator.prototype = {
    current: 64,

    moveNext() {
      if (this.buffer.length > 0) {
        this.current = this.buffer.shift();
        return true;
      } if (this.index >= (this.input.length - 1)) {
        this.current = 64;
        return false;
      }
      const enc1 = base64Codex.indexOf(this.input.charAt(++this.index));
      const enc2 = base64Codex.indexOf(this.input.charAt(++this.index));
      const enc3 = base64Codex.indexOf(this.input.charAt(++this.index));
      const enc4 = base64Codex.indexOf(this.input.charAt(++this.index));

      const chr1 = (enc1 << 2) | (enc2 >> 4);
      const chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      const chr3 = ((enc3 & 3) << 6) | enc4;

      this.current = chr1;

      if (enc3 !== 64) {
        this.buffer.push(chr2);
      }

      if (enc4 !== 64) {
        this.buffer.push(chr3);
      }

      return true;
    }
  };

  return {
    codex: base64Codex,

    encode(input) {
      const output = [];

      const enumerator = new Utf8EncodeEnumerator(input);
      while (enumerator.moveNext()) {
        const chr1 = enumerator.current;

        enumerator.moveNext();
        const chr2 = enumerator.current;

        enumerator.moveNext();
        const chr3 = enumerator.current;

        const enc1 = chr1 >> 2;
        const enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        let enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        let enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = 64;
          enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output.push(this.codex.charAt(enc1) + this.codex.charAt(enc2) + this.codex.charAt(enc3) + this.codex.charAt(enc4));
      }

      return output.join('');
    },

    decode(input) {
      const output = [];

      const enumerator = new Base64DecodeEnumerator(input);
      while (enumerator.moveNext()) {
        const charCode = enumerator.current;
        let charCode2;
        let charCode3;

        if (charCode < 128) {
          output.push(String.fromCharCode(charCode));
        } else if ((charCode > 191) && (charCode < 224)) {
          enumerator.moveNext();
          charCode2 = enumerator.current;

          output.push(String.fromCharCode(((charCode & 31) << 6) | (charCode2 & 63)));
        } else {
          enumerator.moveNext();
          charCode2 = enumerator.current;

          enumerator.moveNext();
          charCode3 = enumerator.current;

          output.push(String.fromCharCode(((charCode & 15) << 12) | ((charCode2 & 63) << 6) | (charCode3 & 63)));
        }
      }

      return output.join('');
    }
  };
}());

export default {
  base64,
  base36: {
    encode(value) {
      if (util.isNaN(+value)) {
        return NaN;
      }

      value = (+value).toString(36);
      return value ? value.toUpperCase() : null;
    },

    decode(value) {
      return parseInt(value, 36);
    }
  }
};
